export enum TemplatePickerMode {
  multi = 'multi',
  single = 'single',
  change = 'change',
}

export enum TemplatePickerModalType {
  change = 'change',
  add = 'add',
}

export enum TemplateStepperState {
  completed = 'completed',
  disabled = 'disabled',
  alert = 'alert',
  active = 'active',
  notSelected = 'notSelected',
}
